import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useAppDispatch } from "@application/store/useStore";
// Import resetFiltersAndPagination from every slice that holds filter/pagination state
import { resetFiltersAndPagination as resetUsers } from "@reducers/users/slice/user-slice";
import { resetFiltersAndPagination as resetRoles } from "@reducers/roles/slice/role-slice";
import { resetFiltersAndPagination as resetAlarmCauses } from "@reducers/alarm-causes/slice/alarm-causes-slice";
import { resetFiltersAndPagination as resetAlarmNotifications } from "@reducers/alarm-notifications/slice/alarm-notifications-slice";
/**
 * Resets all filter, pagination, and sorting state in Redux whenever the user
 * navigates to a different page.  Call this once inside the root `Layout`
 * component so it covers every protected route.
 */
export const useResetOnNavigation = () => {
    const { pathname } = useLocation();
    const dispatch = useAppDispatch();
    const prevPathname = useRef(pathname);
    useEffect(() => {
        // Skip the very first render — we only care about *changes*
        if (prevPathname.current === pathname)
            return;
        prevPathname.current = pathname;
        // AP and node lists intentionally retain their state while a user visits
        // details, settings, or logs and then navigates back.
        dispatch(resetUsers());
        dispatch(resetRoles());
        dispatch(resetAlarmCauses());
        dispatch(resetAlarmNotifications());
    }, [pathname, dispatch]);
};
